import {OAuthDataProps} from "../../context/type";

export const formatDateToLocale = (date: string, userData: OAuthDataProps) => {
    const jwtData =  userData.getJwtData();
    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }
    const newDate = new Date(date);
    const localeDate = newDate.toLocaleDateString(`${jwtData.locale.replace("_","-")}`, options) ?? "";

    return `${localeDate}`;
}